import styled from "styled-components";
import { ReactComponent as ChevronSvg } from "../../assets/icons/chevron-down.svg";

export const DropdownContainer = styled.div`
  display: inline-block;
  width: ${(p) => (p.$fullWidth ? "100%" : "unset")};
`;

export const DropdownButton = styled.button`
  display: flex;
  justify-content: ${(p) => (p.$fullWidth ? "space-between" : "center")};
  align-items: center;
  gap: 4px;

  padding: ${(p) => (p.$multipleSelect ? "12px" : "6px 16px")};
  width: ${(p) => (p.$multipleSelect ? "44px" : "32px")};
  border-radius: ${(p) => (p.$multipleSelect ? "12px" : "100px")};
  border: ${(p) =>
    p.$multipleSelect ? "0.5px solid #325682" : "1px solid #345884"};
  background: ${(p) => (p.$multipleSelect ? "#142743" : "#112238")};

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -0.07px;
  cursor: pointer;
  transition: all 0.2s ease;

  width: ${(p) => (p.$fullWidth ? "100%" : "max-content")};
`;

export const ChevronIcon = styled(ChevronSvg)`
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
`;

export const DropdownMenu = styled.div`
  position: fixed;
  top: ${(props) => props.$top}px;
  left: ${(props) => props.$left}px;
  min-width: ${(props) => props.$width}px;
  background: #112238;
  border: 1px solid #345884;
  border-radius: 8px;
  overflow: hidden;
  z-index: 9999;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  visibility: ${(props) => (props.$isOpen ? "visible" : "hidden")};
  max-height: calc(35px * 6);
  transform: ${(props) =>
    props.$isOpen ? "translateY(0)" : "translateY(-8px)"};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  pointer-events: ${(props) => (props.$isOpen ? "auto" : "none")};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 16px 14px;

  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background: #45608d;
  }

  &::-webkit-scrollbar-thumb {
    cursor: grab;
    background: #2877d9;
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #2877d990;
  }
  &::-webkit-scrollbar-thumb:active {
    background: #2877d9;
    cursor: grabbing;
  }
`;

export const DropdownItem = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  padding-top: 4px;
  padding-bottom: 4px;
  white-space: nowrap;
  letter-spacing: -0.07px;
  opacity: ${(p) => (p.$noClick ? 0.4 : 1)};
  cursor: ${(p) => (p.$noClick ? "default" : "pointer")};
  transition: all 0.3s ease-in-out;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  &:hover {
    padding-left: ${(p) => (p.$active ? "0" : "4px")};
  }

  &:first-child {
    padding-top: 0px;
  }

  &:last-child {
    padding-bottom: 0px;
  }
`;

export const DisturbingCard = styled.div`
  border-radius: 24px;
  background: #4d9dff;

  display: flex;
  height: 16px;
  padding: 2px 4px 2px 4px;
  align-items: center;
  gap: 2px;
  font-weight: 700;
  font-size: 10px;
`;

export const ScrollIcon = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -18px;

  @media (max-width: 768px) {
    display: flex;
  }
`;
